import { SORT_CARS_ARRAY, SEARCH_CARS, SHOW_CAR_CARDS } from '../actionsTypes';
import { setSession, getSession } from '../../utilites';
import { NEWEST_FIRST, CARS_STATE } from '../../constants';

const initialState = getSession(CARS_STATE) || {
  cars: startup.cars,
  orderedBy: NEWEST_FIRST,
  showCarCards: false,
};

const catalogReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case SORT_CARS_ARRAY:
      newState = { ...state, cars: action.payload, orderedBy: action.sortType };
      break;
    case SEARCH_CARS:
      newState = { ...state, cars: action.payload };
      break;
    case SHOW_CAR_CARDS:
      newState = { ...state, showCarCards: action.payload };
      break;
    default:
      return state;
  }
  setSession(CARS_STATE, newState);
  return newState;
};

export default catalogReducer;
